import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CustomersModule} from './customers/customers.module';
import {MapModule} from './map/map.module';
import {NodesModule} from './nodes/nodes.module';
import {ResourceGroupsModule} from './resource-groups/resource-groups.module';
import {IpProfilesModule} from './ip-profiles/ip-profiles.module';
import {VoipPeersModule} from './voip-peers/voip-peers.module';
import {PconsModule} from './pcons/pcons.module';
import {ConnectionsModule} from './connections/connections.module';
import {MaterialModule} from '../material.module';
import {OfflineMapModule} from './offline-map/offline-map.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MapModule,
    OfflineMapModule,
    NodesModule,
    CustomersModule,
    ResourceGroupsModule,
    IpProfilesModule,
    VoipPeersModule,
    PconsModule,
    ConnectionsModule,
    MaterialModule
  ]
})
export class NetworkModule { }
